<template>
  <div>
    <div class="container-scroller" style="background: #f9fafb">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        background-color="#f3f3f3"
        :opacity="0.8"
        loader="spinner"
      ></loading>

      <AuthWrapper @new_language="updateLang">
        <template slot="content">
          <div class="card-background w-100">
            <div>
              <h5 class="pt-3 text-center font-24 font-weight-bold">
                {{ $t("reset_ur_pwd") }}
              </h5>
              <p class="gray4 mb-4 text-center font-14">
                {{ $t("pls_enter") }}
              </p>
            </div>
            <div
              v-if="mssg"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <form v-if="requestpass" @submit.prevent="onSubmit" class="pt-3">
              <div class="form-group">
                <label for="InputEmail">{{ $t("email_add") }}</label>
                <div class="form-group">
                  <input
                    type="email"
                    class="form-control "
                    id="InputEmail"
                    required="required"
                    v-model="email"
                    name="email"
                  />
                </div>
              </div>

              <div class="my-3">
                <button
                  type="submit"
                  class="btn btn-primary w-100"
                  style="border-radius: 5px; font-size:16px !important"
                >
                  {{ $t("reset_pwd") }}
                </button>
              </div>
            </form>

            <div class="text-center pt-5">
              <p class="">
                <router-link to="/login" class="btn-link font-weight-light font-14">{{
                  $t("back_login")
                }}</router-link>
              </p>
            </div>
          </div>
        </template>
      </AuthWrapper>
      <!-- page-body-wrapper ends -->
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import AuthWrapper from "./AuthWrapper.vue";

export default {
  name: "ForgotPassword",
  data() {
    return {
      email: "",
      mssg: "",
      isLoading: false,
      fullPage: true,
      Errormssg: "",
      requestpass: true,
      language: "EN",
      show_drop: false,
      show_drop_mobile: false,
      langKeys: {
        en: "EN",
        fr: "FR",
        sw: "SW",
      },
    };
  },
  components: {
    Loading,
    AuthWrapper,
  },
  methods: {
    ...mapActions(["resetPass", "resetmssg"]),
    onSubmit() {
      this.isLoading = true;
      const user = {
        email: this.email.toLowerCase(),
      };
      this.resetPass(user)
        .then(async (res) => {
          this.isLoading = false;
          if (res.data.success) {
            this.requestpass = false;
            this.mssg = this.$t("pwd_link");
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg = this.$t("user_exist");
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    switchLang: function(lang, val) {
      // this.$i18n.locale = lang;
      this.$emit("new_language", lang);
      this.language = val;
    },
    hideDrop() {
      this.show_drop = false;
    },
    hideDropMobile() {
      this.show_drop_mobile = false;
    },
    updateLang(lang) {
      this.$emit("new_language", lang);
    },
  },
};
</script>

<style scoped>
.visible-append {
  cursor: pointer;
}
.left-column {
  /* padding: 0 3rem 1rem; */
  padding: 0 1rem 1rem 5rem;
  place-items: flex-start;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}
.left-column p {
  color: #5e6a79;
  font-family: Sarabun;
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 140.62%;
}

.left-column h1 {
  line-height: 1.2;
  font-weight: bolder;
  color: #212529;
  font-size: 2.75rem;
}
.left-column .d-block {
  z-index: 3;
}
.img-green {
  position: absolute;
  top: 0;
  left: 0;
  height: 90vh;
  z-index: 1;
}
.page-body-wrapper.full-page-wrapper {
  width: 100%;
  min-height: 100vh;
  padding-top: 0;
  max-width: 35rem;
}
.row-login {
  position: absolute;
  width: 100%;
  bottom: 0;
}
.lang {
  float: right;
  position: relative;
  top: 4rem;
}
/* .left-column .d-block {
  position: relative;
  top: 50%;
} */
.dropdown-lang {
  background: #ffffff;
  border: 0.3px solid rgba(99, 99, 99, 0.25);
  box-shadow: 0px 20px 50px rgba(29, 53, 71, 0.06);
  border-radius: 3px;
  z-index: 1000 !important;
  top: 2rem;
  color: #5e6a79;
  /* width: calc(100% - 1.5rem); */
}
input[type="radio"] {
  border: 1px solid green !important;
}
input[type="radio"]:checked {
  background-color: red !important;
}
.radio-btn {
  border: 1px solid red !important;
}
.hover-item {
  padding: 8px;
}
.hover-item:hover {
  background-color: #f6f8f9;
}
.gricd-logo {
  /* position: absolute;
  top: 3rem;
  height: 5rem;
  z-index: 3; */

  position: absolute;
  top: 5rem;
  height: 4rem;
  z-index: 3;
  /* left: 3rem; */
  left: 0rem;
}
.right-form .col-12 {
  /* height: 75%; */
  top: 4rem;
}
.right-form {
  flex-grow: 1;
}
@media (max-width: 576px) {
  .img-green {
    height: 50vh;
    width: calc(100% - 10rem);
  }
  .left-column h1 {
    margin-top: 5rem;
    font-size: 2rem;
  }
  .gricd-logo {
    /* position: absolute;
    top: 2rem;
    height: 2rem;
    z-index: 3;
    left: -1rem; */
    position: absolute;
    top: 1rem;
    height: 2rem;
    z-index: 3;
    left: 0rem;
  }
  .hide-lang {
    display: none !important;
  }
  .mobile-lang {
    top: 2.6rem;
    margin-left: auto;
    z-index: 10;
  }
  .left-column {
    /* padding: 0 3rem 1rem; */
    padding: 0 3rem 1rem 3rem;
    place-items: flex-start;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
  }
  .vh-100 {
    height: auto !important;
  }
  .page-body-wrapper.full-page-wrapper {
    min-height: auto;
  }
}
@media (max-width: 1250px) and (min-width: 900px) {
  .gricd-logo {
    position: absolute;
    top: 3rem;
    height: 3rem;
    z-index: 3;
    /* left: 2rem; */
    left: 0rem;
  }
}

@media (max-width: 2100px) and (min-width: 1680px) {
  .gricd-logo {
    position: absolute;
    /* top: 7rem; */
    height: 5rem;
    z-index: 3;
    left: 0rem;
  }
  .left-column {
    padding: 0 1rem 1rem 5rem;
  }
  .left-column h1 {
    line-height: 1.2;
    font-weight: bolder;
    color: #212529;
    /* font-size: 3.75rem; */
    font-size: 3.4rem;
  }
  .left-column p {
    color: #5e6a79;
    font-family: Sarabun;
    font-style: normal;
    font-weight: 600;
    font-size: 1.2rem !important;
    line-height: 140.62%;
  }
  .img-green {
    position: absolute;
    top: 0;
    left: 0;
    height: 88vh;
    z-index: 1;
  }
  .right-form {
    flex-grow: 1;
  }
  .right-form .col-12 {
    display: flex;
    flex-flow: column;
    /* width: 100%; */
    /* height: 75%; */
    top: 7rem;
  }

  .right-form .col-12 .auth-form-transparent {
    width: 100% !important;
    height: 100%;
    display: flex;
    flex-flow: column;
    justify-content: space-evenly;
  }
  .page-body-wrapper.full-page-wrapper {
    width: 100%;
    min-height: 100vh;
    padding-top: 0;
    max-width: 39rem;
  }
  .brand-logo img {
    height: 4rem;
  }
  h5 {
    font-size: 1.2rem;
  }
  .auth form .form-group label {
    font-size: 1.05rem;
  }
  .auth .brand-logo {
    /* margin-bottom: 0; */
  }
  p {
    font-size: 1.05rem;
  }
  .btn {
    font-size: 1.2rem;
  }
  .small {
    font-size: 0.875rem;
  }
}
.card-background {
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(138, 142, 148, 0.05);
  border-radius: 10px;
  padding: 2rem 1.5rem;
}
</style>

<i18n>
{
	"en": {
		"acc": "Don't have an account?",
		"back_login": "Back to Login",
		"change-lang": "Change Language",
		"email": "Email.",
		"email_add": "Email Address",
		"fgt-pwd": "Forgot Password?",
		"login": "Log In",
		"password": "Password",
		"pls_enter": "Please enter your registered email address",
		"pwd_link": "Password link has been sent to your email address",
		"real-time": "With real-time data-backed decisions.",
		"reset_pwd": "Reset Password",
		"reset_ur_pwd": "Reset your password",
		"scale": "Scale your Operation and",
		"scale-2": "increase profitability",
		"signup": "Sign Up",
		"user_exist": "User Doesn't Exist",
		"welcome": "Welcome back! Please login to your account.",
		"zero-stress": "No stress, zero hassle."
	},
	"es": {
		"acc": "¿No tienes una cuenta?",
		"back_login": "Atrás para iniciar sesión",
		"change-lang": "Cambiar idioma",
		"email": "Correo electrónico.",
		"email_add": "Dirección de correo electrónico",
		"fgt-pwd": "¿Se te olvidó tu contraseña?",
		"login": "Iniciar sesión",
		"password": "Contraseña",
		"pls_enter": "Por favor ingrese su dirección de correo electrónico registrada",
		"pwd_link": "El enlace de contraseña ha sido enviado a su dirección de correo electrónico",
		"real-time": "Con decisiones respaldadas por datos en tiempo real.",
		"reset_pwd": "Restablecer la contraseña",
		"reset_ur_pwd": "Restablecer su contraseña",
		"scale": "Escale su operación y",
		"scale-2": "aumentar la rentabilidad",
		"signup": "Regístrate",
		"user_exist": "El usuario no existe",
		"welcome": "¡Bienvenido de nuevo! Por favor, ingrese a su cuenta.",
		"zero-stress": "Sin estrés, sin complicaciones."
	},
	"fr": {
		"acc": "Vous n'avez pas de compte?",
		"back_login": "Retour connexion",
		"change-lang": "Changer de langue",
		"email": "E-mail.",
		"email_add": "Adresse e-mail",
		"fgt-pwd": "Mot de passe oublié?",
		"login": "S'identifier",
		"password": "Mot de passe",
		"pls_enter": "Veuillez saisir votre adresse e-mail enregistrée",
		"pwd_link": "Le lien du mot de passe a été envoyé à votre adresse e-mail",
		"real-time": "Avec des décisions fondées sur des données en temps réel.",
		"reset_pwd": "réinitialiser le mot de passe",
		"reset_ur_pwd": "réinitialisez votre mot de passe",
		"scale": "Faites évoluer votre opération et",
		"scale-2": "Augmenter la rentabilité",
		"signup": "S'inscrire",
		"user_exist": "L'utilisateur n'existe pas",
		"welcome": "Nous saluons le retour! Veuillez vous connecter à votre compte.",
		"zero-stress": "Pas de stress, zéro souci."
	},
	"sw": {
		"acc": "Hauna akaunti?",
		"back_login": "Rudi kwa Ingia",
		"change-lang": "Badilisha Lugha",
		"email": "Barua pepe.",
		"email_add": "Barua pepe",
		"fgt-pwd": "Umesahau nywila?",
		"login": "Ingia",
		"password": "Nenosiri",
		"pls_enter": "Tafadhali ingiza barua pepe yako iliyosajiliwa",
		"pwd_link": "Kiungo cha nenosiri kimetumwa kwa anwani yako ya barua pepe",
		"real-time": "Kwa maamuzi ya wakati halisi yanayoungwa mkono na data.",
		"reset_pwd": "Rudisha Nenosiri",
		"reset_ur_pwd": "Weka upya Nenosiri lako",
		"scale": "Ongeza Uendeshaji wako na",
		"scale-2": "kuongeza faida",
		"signup": "Jisajili",
		"user_exist": "Mtumiaji Hayupo",
		"welcome": "Karibu tena! Tafadhali ingia kwenye akaunti yako.",
		"zero-stress": "Hakuna dhiki, sifuri shida."
	}
}
</i18n>
